import { useState } from "react";

export default function LegalSearchBox({ onSearch, loading }) {
  const [q, setQ] = useState("");

  return (
    <div className="flex gap-2">
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        className="flex-1 px-3 py-2 rounded-xl border bg-white"
        placeholder="Search in this document (e.g., election, nomination, audit)…"
      />
      <button
        onClick={() => onSearch?.(q)}
        disabled={loading || !q.trim()}
        className="px-4 py-2 rounded-xl bg-emerald-600 text-white font-semibold disabled:opacity-60"
      >
        {loading ? "Searching…" : "Search"}
      </button>
    </div>
  );
}
